module.exports = __webpack_public_path__ + "img/3D-Rekonstruktion.1ec988c3.jpg";